<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="page-title">
        <h1>{{ page_title }}</h1>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="bisual-table">
          <div class="bisual-table-container">
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="working_contract_id">
                <th mat-header-cell *matHeaderCellDef>Contrato</th>
                <td mat-cell *matCellDef="let item">#{{ item.working_contract_id }}</td>
              </ng-container>

              <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef>Año</th>
                <td mat-cell *matCellDef="let item">{{ item.year }}</td>
              </ng-container>

              <ng-container matColumnDef="holidays_calendar_country_zone_id">
                <th mat-header-cell *matHeaderCellDef>Población</th>
                <td mat-cell *matCellDef="let item; let i = index">
                  @if (item.year < currentYear || (item.year == currentYear && item.holidays_calendar_country_zone_id != null)) {
                    {{ item.holidays_calendar_country_zone.name }}
                  } @else {
                    <mat-form-field appearance="outline" class="nobottom">
                      <mat-label>Población</mat-label>
                      <input type="text" matInput [formControl]="autocompleteSearchInputControls[i]" [matAutocomplete]="auto" />
                      <mat-autocomplete
                        #auto="matAutocomplete"
                        [displayWith]="displayFn"
                        (optionSelected)="onAutocompleteClickCountryZone($event, i)"
                      >
                        @for (cz of country_zones; track cz) {
                          <mat-option [value]="cz">{{ cz.name }} ({{ cz.parent?.name }})</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
